// extracted by mini-css-extract-plugin
module.exports = {"content":"page_content__VL3T3"};